import api from '@/api/api'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async getSurveysNumber({ dispatch }) {
      return new Promise((resolve, reject) => {
        api
          .get('/cms/surveys/get_surveys_number')
          .then(response => {
            if (response.data.ok) {
              resolve(response.data.data)
            } else {
              dispatch('alerts/add', { text: response.data.message, color: 'error' }, { root: true })
              reject(response.data)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    async getExcelSurveys({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api
          .get('/cms/surveys/get_excel_surveys', {
            params: obj
          })
          .then(response => {
            if (response.data.ok) {
              resolve(response.data.data)
            } else {
              dispatch('alerts/add', { text: response.data.message, color: 'error' }, { root: true })
              reject(response.data)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    }
  },
  getters: {}
}
